import React from 'react';
import './background.css'
import Regiform from './Regiform';



function Enroll() {
    return (
    <div >
    

        <Regiform />

    </div>

    )
}

export default Enroll;